<div class="v-one-card-footer">
  @if (showPaymentOptions()) {
    <div class="v-one-card-footer__payment-options">
      @if (hasAdvance) {
        <div class="v-one-card-footer__payment-item">
          <label
            class="v-one-card-footer__payment-option"
            [class.v-one-card-footer__payment-option--selected]="
              advanceSelected()
            "
          >
            <input
              type="checkbox"
              class="v-one-card-footer__payment-checkbox"
              [checked]="advanceSelected()"
              (change)="onAdvanceToggle($event)"
            />
            <span class="v-one-card-footer__payment-label">
              {{ 'card.payment.useAdvance' | translate }}
              ({{
                advanceAmount | currency: currency : 'symbol-narrow' : '1.0-0'
              }})
            </span>
          </label>

          @if (advanceSelected()) {
            <v-one-button
              [text]="'card.action.removePayment' | translate"
              variant="secondary"
              className="v-one-card-footer__payment-remove"
              (buttonClick)="toggleAdvance(false)"
            />
          }
        </div>
      }

      @if (hasFavorBalance) {
        <div class="v-one-card-footer__payment-item">
          <label
            class="v-one-card-footer__payment-option"
            [class.v-one-card-footer__payment-option--selected]="
              favorBalanceSelected()
            "
          >
            <input
              type="checkbox"
              class="v-one-card-footer__payment-checkbox"
              [checked]="favorBalanceSelected()"
              (change)="onFavorBalanceToggle($event)"
            />
            <span class="v-one-card-footer__payment-label">
              {{ 'card.payment.useFavorBalance' | translate }}
              ({{
                favorBalanceAmount
                  | currency: currency : 'symbol-narrow' : '1.0-0'
              }})
            </span>
          </label>

          @if (favorBalanceSelected()) {
            <v-one-button
              [text]="'card.action.removePayment' | translate"
              variant="secondary"
              className="v-one-card-footer__payment-remove"
              (buttonClick)="toggleFavorBalance(false)"
            />
          }
        </div>
      }
    </div>
  }

  @if (
    showDropdown && dropdownOptions().length > 0 && cardState !== 'rejected'
  ) {
    <v-one-dropdown-button
      class="v-one-card-footer__dropdown"
      [class.v-one-card-footer__dropdown--portfolio]="isPortfolioCard()"
      [options]="dropdownOptions()"
      [variant]="'secondary'"
      [placeholder]="
        ctaLabel ??
        (dropdownOptions().length === 2
          ? 'global.notes.create-note'
          : ('card.action.changeStatus' | translate))
      "
      [showSelectionCount]="false"
      (selectionChange)="handleDropdownSelect($event)"
      [withDot]="!isPortfolioCard() && relatedNotes().length > 0"
      [notes]="relatedNotes()"
    >
    </v-one-dropdown-button>
  } @else if (showDropdown && ctaLabel && ctaAction) {
    <v-one-button
      class="v-one-card-footer__dropdown"
      [text]="ctaLabel | translate"
      [variant]="'secondary'"
      (buttonClick)="handleDirectAction()"
    />
  }
</div>
